export const facebookShareUrl = (title: string, url: string) =>
  `https://www.facebook.com/sharer.php?quote=${encodeURI(title)}&u=${url}`;

export const linkeinShareUrl = (url: string) =>
  `https://www.linkedin.com/sharing/share-offsite?url=${url}`;

export const twitterShareUrl = (title: string, url: string) =>
  `https://twitter.com/intent/tweet?text=${encodeURI(title)}&url=${url}`;

export const mailShareUrl = (text: string, title: string, subtitle: string, url: string) =>
  `mailto:?subject=${encodeURI(title)}&body=${encodeURI(`${subtitle} ${text} ${url}`)}`;

export const whatsAppShareUrl = (title: string, url: string) =>
  `https://wa.me/?text=${encodeURI(`${title} ${url}`)}`;
